<template class="">
    <div class="login-page">
    <div class="alert" role="alert" id="snackbar">
      <strong>Error:</strong> {{ errorMsg }}
    </div>
    <div class="alert" role="alert" id="snackbar_reset">{{ resetMsg }}</div>
    <div class="form bg-secondary">
        <form class="login-form" @submit.prevent="login">
        <input type="text" placeholder="Email" v-model="email">

        <div class="password-field">
          <input id="password" type="password" placeholder="Password" v-model="password">
          <span class="eye-toggle" @click="showPswd"><i class="fa fa-eye"></i></span>
        </div>
        <button type="button" class="btn-sm btn-info" @click="logIn">login</button>
        <p class="message">Forgot password? <a href="#" data-toggle="modal" data-target="#myModal">Reset</a></p>
        <p class="g-matrix">Powerd by <a href="http://g-matrixsystems.com/" target="_blank">G-Matrix Systems</a></p>
    </form>
    </div>

  <!-- PASS RESET MODAL -->
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Request password reset.</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form class="pass_reset">
             <input 
             type="email" 
             placeholder="Enter email you are registered with." 
             id="email_pass_reset"
             class="email_pass_reset" 
             v-model="email_pass_reset" required>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-success" data-dismiss="modal" @click="pass_reset()">Submit</button>
          <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
// import router from '../../store/router'
import http from '../../services/http'
export default {
  name: 'Login',
    data() {
      return {
        email: '',
        password: '',
        email_pass_reset: '',
        resetMsg: '',
        errorMsg: ''
      }
    },
    
    methods: {
    logIn() {
      this.errorMsg = ''
      this.$store.dispatch('retrieveToken', {
        email: this.email,
        password: this.password,
      }).catch((error) => {
        this.showLoginError(error)
      })
    },

    // Show the error that actually happened, not a blanket "wrong password".
    // A 429 means rate-limited, a network failure means the server is unreachable —
    // telling the user to check their password in those cases is misleading.
    showLoginError(error) {
      const res = error && error.response
      let msg
      if (!res) {
        msg = 'Cannot reach the server. Check your connection and try again.'
      } else if (res.status === 429) {
        msg = (res.data && res.data.message) || 'Too many attempts. Please wait a minute and try again.'
      } else if (res.status === 401) {
        msg = 'Incorrect email or password.'
      } else {
        msg = (res.data && res.data.message) || 'Unable to log in. Please try again.'
      }
      this.errorMsg = msg
      const x = document.getElementById('snackbar')
      if (!x) return
      x.className = 'show'
      setTimeout(() => { x.className = x.className.replace('show', '') }, 5000)
    },

     showPswd() {
      var x = document.getElementById("password")
      if(x.type === "password") {
        x.type = "text"
      } else {
        x.type = "password"
      }
     },

     // Request a reset link. The API always replies with the same message so it
     // can't be used to discover which addresses are registered.
     pass_reset() {
        const email = (this.email_pass_reset || '').trim()
        if (!email) {
          this.showResetMsg('Please enter the email address you are registered with.')
          return
        }
        http.post('/api/password/forgot', { email })
          .then((res) => {
            this.showResetMsg(res.data.message)
            this.email_pass_reset = ''
          })
          .catch((error) => {
            const msg = (error.response && error.response.data && error.response.data.message)
              || 'Could not send the reset email. Please try again later.'
            this.showResetMsg(msg)
          })
     },

     showResetMsg(msg) {
        this.resetMsg = msg
        const x = document.getElementById('snackbar_reset')
        if (!x) return
        x.className = 'show'
        setTimeout(() => { x.className = x.className.replace('show', '') }, 6000)
     }
    }
}
</script>

<style scoped>
.login-page {
  width: 100%;
  max-width: 400px;
  padding: 0 16px;
  margin: auto;
  display: flex;
  align-items: center;
  min-height: 100vh;
}

.form {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 40px 36px;
  text-align: center;
  background: var(--surface) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
  color: var(--text);
}
.form input {
  font-family: var(--font-sans);
  outline: 0;
  background: var(--bg-base);
  color: var(--text);
  width: 100%;
  border: 1px solid var(--border);
  margin: 0 0 15px;
  padding: 12px 14px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: var(--radius-sm);
}
.form input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.login-form button {
  width: 100%;
  padding: 12px;
  margin-top: 4px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: var(--accent-contrast);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.login-form button:hover {
  background: var(--accent-hover);
}

.form .message {
  margin: 18px 0 0;
  color: var(--text-muted);
  font-size: 12px;
}
.form .message a {
  color: #4CAF50;
  text-decoration: none;
}

.form .g-matrix {
  margin-top: 32px;
  color: var(--text-faint);
  font-size: 12px;
  text-align: center;
}
.form .g-matrix a {
  color: var(--accent);
  text-decoration: none;
}

.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before, .container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #EF3B3A;
}

/* password field with the show/hide eye toggle */
.form .password-field {
  position: relative;
  margin: 0 0 15px;
}
.form .password-field input {
  margin: 0;
  padding-right: 42px; /* room for the eye */
}
.eye-toggle {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  color: var(--text-muted);
  cursor: pointer;
  z-index: 2;
  line-height: 1;
}
.eye-toggle:hover {
  color: var(--accent);
}

/* --- Password-reset modal: match the app's dark theme --- */
.modal-content {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  color: var(--text);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-header {
  border-bottom: 1px solid var(--border);
  padding: 16px 20px;
}

.modal-title {
  color: var(--text);
  font-size: 17px;
  font-weight: 700;
}

.modal-body {
  padding: 18px 20px;
  color: var(--text);
}

.modal-footer {
  border-top: 1px solid var(--border);
  padding: 14px 20px;
}

.close {
  float: right;
  color: var(--text-muted);
  opacity: 1;
  text-shadow: none;
  font-size: 24px;
  line-height: 1;
}

.close:hover {
  color: var(--text);
  opacity: 1;
}

.email_pass_reset {
  font-family: var(--font-sans);
  outline: 0;
  background: var(--bg-base);
  color: var(--text);
  width: 100%;
  border: 1px solid var(--border);
  margin: 0;
  padding: 12px 14px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: var(--radius-sm);
}

.email_pass_reset:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.email_pass_reset::placeholder {
  color: var(--text-faint);
}

/* Reset-request feedback toast */
#snackbar_reset {
  visibility: hidden;
  min-width: 280px;
  max-width: 460px;
  margin-left: -230px;
  text-align: center;
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--accent);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow);
  padding: 12px 16px;
  position: fixed;
  z-index: 1100;
  left: 50%;
  top: 10px;
  font-size: 14px;
}

#snackbar_reset.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}

.alert {
    width: 30%;
}

#snackbar {
	visibility: hidden;
	min-width: 250px;
  margin-left: -230px;
  text-align: center;
  background-color: #ff9966 !important;
	border-radius: 2px;
	padding: 5px;
	position: fixed;
	z-index: 1;
	left: 50%;
  top: 10px;
	font-size: 17px;
  }
  
  #snackbar.show {
	visibility: visible;
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }
</style>>